import React from "react";
import "./App.scss";
import topImage from "./static/topImage.png";
import StopImage from "./static/StopImage.png";
import arrow from "./static/arrow-right.svg";
import JoinSchoolBox from "./components/JoinSchoolBox";
import JoinSchoolBox2 from "./components/JoinSchoolBox2";
import Axis from "./static/axis.png";
import sy from "./static/sy.png";
import hs from "./static/hs.png";
import cl from "./static/cl.png";
import hg from "./static/hg.png";
import ss from "./static/ss.jpg";
import ks from "./static/ks.jpg";
import { BiErrorAlt } from "react-icons/bi";

/* eslint react-hooks/exhaustive-deps:0  */

const App = () => {
  return (
    <div>
      <img src={topImage} className="topImage" alt="" />
      <img src={StopImage} className="StopImage" alt="" />

      <div className="blank" />

      {/* 全部containerに入れた */}
      <div className="container">
        <p className="flexwrap">
          <span>参加無料！</span>
          <span>入退場自由！</span>
          <span>スマホでOK！</span>
          <span>事前登録制</span>
          <span>小学生・中学生・保護者対象</span>
        </p>

        <div className="blank" />
        <h3 className="padding20 blue back-skyblue">日時・対象</h3>
        <div className="content">
          <p>日時：2020/09/27(日)</p>
          <p>対象：小学４年生～中学３年生全般と保護者</p>
          <p>
            入場無料！　事前予約制となります。応募方法は以下をご覧ください。
          </p>
        </div>

        <h3 className="padding20 back-skyblue blue" id="form">
          応募方法
        </h3>
        <p className="content">
          私学合同説明会、講演会の参加には事前登録が必要です。また、オンラインでの参加にはZOOMの登録・設定が必要です。下の申し込みフォームより登録お願いします。
          <p className="anno">
            ※参加には応募フォーム内の「保護者の同意と個人情報の取り扱いについて」の同意が必要です。ご応募いただいた個人情報は、応募フォーム内の「保護者の同意と個人情報の取り扱いについて」に従い、厳正に管理いたします。
            当日使用するスマホ・PCに、「zoom」アプリをインストールしておいてください。
            （iPhoneは
            <a
              href="https://apps.apple.com/jp/app/zoom-cloud-meetings/id546505307"
              target="_blank"
              rel="noopener noreferrer"
            >
              コチラ
            </a>
            、Androidは
            <a
              href="https://play.google.com/store/apps/details?id=us.zoom.videomeetings"
              target="_blank"
              rel="noopener noreferrer"
            >
              コチラ
            </a>
            、PCは
            <a
              href="https://zoom.us/download#client_4meeting"
              target="_blank"
              rel="noopener noreferrer"
            >
              コチラ
            </a>
            、インストール所要時間5分程度）
          </p>
        </p>
        <a
          className="form"
          target="_blank"
          rel="noopener noreferrer"
          href="https://form.hokkaido-np.co.jp/shingaku202009"
        >
          <button>
            参加申し込みフォーム
            <img src={arrow} alt="" />
          </button>
        </a>
        <div className="blank" />

        <h3 className="padding20 blue back-skyblue">参加者特典</h3>
        <div className="content">
          <div className="padding20 back-grey">
            オンライン合同説明会参加特典
          </div>
          <p className="present">
            <span className="font-size-large blue">●</span>参加高校６校中４校の
            説明に参加した生徒さん（保護者のみの参加も含む）に、
            DOチャレンジをプレゼント！
          </p>
          <p className="present">
            <span className="font-size-large blue">●</span>
            参加中学校３校中全ての
            説明に参加した児童さん（保護者のみの参加も含む）に、
            週刊まなぶん４週分をプレゼント！
          </p>
          <div className="padding20 back-grey">対面相談会参加特典</div>
          <p className="present">
            <span className="font-size-large blue">●</span>
            参加高校２校の説明に参加した生徒さん（保護者のみの参加も含む）に
            、DOチャレンジをプレゼント！
          </p>
        </div>

        <div className="blank" />
        <h3 className="padding20 blue back-skyblue">プログラム</h3>
        <div className="content">
          <p>
            <span className="font-size-large blue">●</span>
            オンラインZOOMセミナー
          </p>
          <p>
            <span className="font-size-large blue">●</span>
            対面(DO-BOX会場)合同学校説明会
          </p>
          <p>
            <span className="font-size-large blue">●</span>
            オンラインZOOM講演会
          </p>
        </div>

        <h3 className="padding20 blue back-skyblue">オンラインZOOM講演会</h3>
        <div className="content">
          <p>
            <span className="font-size-large blue">●</span>13:00~13:45
          </p>
          <p>
            テーマ
            <span className="font-size-large">
              「コロナウィルス禍での遅れを取り戻す勉強法」
            </span>
          </p>
          <p>
            講師：
            <span className="font-size-large">関口和宏</span>氏
            <a
              className="axis"
              href="https://axis-kobetsu.jp/?_ebx=cb8q145grs.1536466836.7ckdzr2"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={Axis} alt="" />
            </a>
            <span className="font-weight-small font-size-small">
              株式会社ワオ・コーポレーション（個別指導Axis）北海道統括本部責任者
            </span>
          </p>
        </div>
        <a
          className="form"
          target="_blank"
          rel="noopener noreferrer"
          href="https://form.hokkaido-np.co.jp/shingaku202009"
        >
          <button>
            参加申し込みフォーム
            <img src={arrow} alt="" />
          </button>
        </a>

        <div className="blank" />

        <h3 className="padding20 blue back-skyblue">オンラインZOOMセミナー</h3>
        <div className="content">
          <div className="padding20 back-grey">
            午前の部<span className="font-size-large blue">●</span>10:00~12:40
          </div>
          <p className="font-weight-small padding20">
            クラーク記念国際高等学校、札幌光星高等学校、札幌新陽高等学校、札幌聖心女子学院高等学校、北星学園女子高等学校、北海学園札幌高等学校
          </p>

          <div className="padding20 back-grey">
            午後の部<span className="font-size-large blue">●</span>14:00~17:00
          </div>
          <p className="font-weight-small padding10">
            札幌光星中学校、札幌聖心女子学院中学校、北星学園女子中学校
          </p>
        </div>

        <a
          className="form"
          target="_blank"
          rel="noopener noreferrer"
          href="https://form.hokkaido-np.co.jp/shingaku202009"
        >
          <button>
            参加申し込みフォーム
            <img src={arrow} alt="" />
          </button>
        </a>

        <div className="blank" />
        <h3 className="padding20 back-skyblue blue">DO-BOX対面相談会</h3>
        <div className="content">
          <div className="padding20 back-grey">
            午後の部<span className="font-size-large blue">●</span>
            14:00~17:00
          </div>
          <p className="font-weight-small padding20">
            クラーク記念国際高等学校、札幌新陽高等学校
          </p>
          <p className="COVID">
            <BiErrorAlt className="icon" />
            コロナウイルス感染予防のため、先着１２０人に達した時点で応募を締め切ります。
          </p>
          <p className="COVID">
            <BiErrorAlt className="icon" />
            2020/9/19 追記:定員に達したため、受付を終了いたしました。
          </p>
        </div>

        <div className="blank" />

        <h3 className="padding20 back-skyblue blue">対面相談会会場</h3>
        <div className="content">
          <h3 className="fs-xlarge">DO-BOX</h3>
          <p className="padding10 font-weight-small font-size-small">
            北海道新聞社 札幌本社1F　札幌市中央区大通り西3-6
          </p>
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2915.031151246833!2d141.35083661547873!3d43.061812379146!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x5f0b299da74f5609%3A0xb29b5fd865d4e264!2z5YyX5rW36YGT5paw6IGe56S-IOacreW5jOacrOekvg!5e0!3m2!1sja!2sjp!4v1599315414510!5m2!1sja!2sjp"
            width="95%"
            height="450"
            frameBorder="0"
            allowFullScreen=""
            aria-hidden="false"
            tabIndex="0"
            title="map"
          ></iframe>
        </div>

        <div className="blank" />
        <h3 className="padding20 back-skyblue blue">タイムテーブル</h3>
        <div className="content">
          <table cellSpacing="0">
            <tbody>
              <tr>
                <th></th>
                <td className="leftline">Aルーム</td>
                <td className="leftline">Bルーム</td>
                <td className="leftline">Cルーム</td>
                <td className="leftline">Dルーム</td>
                <td className="leftline">Eルーム</td>
                <td className="leftline">Fルーム</td>
              </tr>
              <tr>
                <th></th>
                <td className="leftline">札幌聖心女子学院高等学校</td>
                <td className="leftline">北星学園女子高等学校</td>
                <td className="leftline">札幌光星高等学校</td>
                <td className="leftline">北海学園札幌高等学校</td>
                <td className="leftline">札幌新陽高等学校</td>
                <td className="leftline">クラーク記念国際高等学校</td>
              </tr>
              <tr>
                <th>9:30 - 10:00</th>
                <td colSpan="6">受付開始</td>
              </tr>
              <tr>
                <th>10:00 - 10:10</th>
                <td colSpan="6">開始の挨拶・学生振り分け</td>
              </tr>
              <tr>
                <th>10:10 - 10:40</th>
                <td colSpan="6">午前オンライン　1ターム</td>
              </tr>
              <tr>
                <th>10:40 - 10:50</th>
                <td colSpan="6">休憩・入替時間</td>
              </tr>
              <tr>
                <th>10:50 - 11:20</th>
                <td colSpan="6">午前オンライン　2ターム</td>
              </tr>
              <tr>
                <th>11:20 - 11:30</th>
                <td colSpan="6">休憩・入替時間</td>
              </tr>
              <tr>
                <th>11:30 - 12:00</th>
                <td colSpan="6">午前オンライン　3ターム</td>
              </tr>
              <tr>
                <th>12:00 - 12:10</th>
                <td colSpan="6">休憩・入替時間</td>
              </tr>
              <tr>
                <th>12:10 - 12:40</th>
                <td colSpan="6">午前オンライン　4ターム</td>
              </tr>
              <tr>
                <th>12:40 - 13:00</th>
                <td colSpan="6">休憩</td>
              </tr>
              <tr>
                <th>13:00 - 13:45</th>
                <td colSpan="6">
                  オンラインZOOM講演会「コロナウイルス禍での遅れを取り戻す勉強法」　
                  <br />
                  講師：関口和宏氏　株式会社ワオ・コーポレーション（個別指導Ａｘｉｓ）北海道統括本部/責任者
                </td>
              </tr>
              <tr>
                <th></th>
                <td className="leftline">札幌聖心女子学院中学校</td>
                <td className="leftline">北星学園女子中学校</td>
                <td className="leftline">札幌光星中学校</td>
                <td className="leftline">北海学園札幌高等学校</td>
                <td className="leftline">札幌新陽高等学校</td>
                <td className="leftline rightline">クラーク記念国際高等学校</td>
              </tr>
              <tr>
                <th>13:45 - 14:00</th>
                <td colSpan="3">休憩・入替時間</td>
                <td className="back-grey2"></td>
                <td colSpan="2" className="nonebottomline">
                  開場（対面会場）
                </td>
              </tr>

              <tr>
                <th>14:00 - 14:30</th>
                <td colSpan="3">午後オンライン　1ターム</td>
                <td rowSpan="7" className="back-grey2">
                  終了
                </td>
                <td rowSpan="7" colSpan="2" className="nonetopline">
                  対面説明会
                  <p className="COVID">
                    <BiErrorAlt className="icon" />
                    コロナウイルス感染予防のため、先着１２０人に達した時点で応募を締め切ります。
                  </p>
                  <p className="COVID">
                    <BiErrorAlt className="icon" />
                    2020/9/19 追記:定員に達したため、受付を終了いたしました。
                  </p>
                </td>
              </tr>
              <tr>
                <th>14:30 - 14:40</th>
                <td colSpan="3">休憩・入替時間</td>
              </tr>
              <tr>
                <th>14:40 - 15:10</th>
                <td colSpan="3">午後オンライン　2ターム</td>
              </tr>
              <tr>
                <th>15:10 - 15:20</th>
                <td colSpan="3">休憩・入替時間</td>
              </tr>
              <tr>
                <th>15:20 - 15:50</th>
                <td colSpan="3">午後オンライン　3ターム</td>
              </tr>
              <tr>
                <th>15:50 - 16:00</th>
                <td colSpan="3">休憩・入替時間</td>
              </tr>
              <tr>
                <th>16:00 - 16:30</th>
                <td colSpan="3">午後オンライン　4ターム</td>
              </tr>
              <tr>
                <th>~17:00</th>
                <td colSpan="6">イベント終了</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="blank" />

        <h3 className="padding20 blue back-skyblue">参加校</h3>
        <div className="flexwrap content">
          <JoinSchoolBox2
            class="cl"
            img={cl}
            soudankai={true}
            name="クラーク記念国際高等学校"
            address1="札幌市中央区大通東8丁目1-61"
            address2="札幌市白石区平和通2丁目北11-18"
            postalCode1="060-0041"
            postalCode2="003-0029"
            phoneNumber="011-233-5515"
            desc="圧倒的に英語力を伸ばす国際教育、実社会に近づくキャリア教育、プログラミングも学べるICT教育など、柔軟で多彩なカリキュラムを展開しています。2021年にはコンサドーレと産学連携しスポーツコース男子サッカー専攻が始動。ここにしかない学びがあります。"
            url="https://www.clark.ed.jp/"
          />

          <JoinSchoolBox
            class="hs"
            img={hs}
            soudankai={false}
            name="北星学園女子高等学校"
            address="札幌市中央区南4条西17丁目2-2"
            postalCode="064-8523"
            phoneNumber="011-561-7153"
            desc="アメリカ人女性宣教師が創立した歴史ある女子校で、創立時から「社会に役立つ実践的知識の習得」「聖書に基づくこころの教育」を建学の精神として教育を展開しています。普通科・英語科・音楽科を擁し、希望進路に合わせた学びと放課後活動が充実しています。"
            url="http://www.hokusei-ghs-jh.ed.jp/"
          />
          <JoinSchoolBox
            class="hs"
            img={hs}
            soudankai={false}
            name="北星学園女子中学校"
            address="札幌市中央区南4条西17丁目2-2"
            postalCode="064-8523"
            phoneNumber="011-561-7153"
            desc="アメリカ人女性宣教師が創立した歴史ある女子校です。様々な経験を通じて自主・自立を育む教育を実践しています。グローバルなコミュニケーション力を養う「カナダプロジェクト」や実社会に直結する「商品開発プロジェクト」など独自プログラムを展開します。"
            url="http://www.hokusei-ghs-jh.ed.jp/"
          />
          <JoinSchoolBox
            class="hg"
            img={hg}
            soudankai={false}
            name="北海学園札幌高等学校"
            address="札幌市豊平区旭町4丁目1番42号"
            postalCode="062-8603"
            phoneNumber="011-841-1161"
            desc="「ガクサツ　ワクワク」 創立「100周年」を迎えた北海学園札幌高等学校。1年次は、特進・総進コース、2年次からは、特進・総進・グローバル・メディカルプレップコースの4コース制が導入され、各コースとも個性的な授業や活動を実施。中学校にはない部活動もたくさん!新たなチャレンジも可能です。大学との連携も着実に進行中！"
            url="https://www.hgs.ed.jp/"
          />
          <JoinSchoolBox
            class="sy"
            img={sy}
            soudankai={true}
            name="札幌新陽高等学校"
            address="札幌市南区澄川5条7丁目1-1"
            postalCode="005-0005"
            phoneNumber="011-821-6161"
            desc="内申ランクに関係無く、今からのあなたのがんばりで合格できる「パスポート制度」が新陽にはあります。「入試部長が話す新陽入試データ」・「がんばりを合格に直結させるコツ」・「３年間の新陽ライフを楽しくするポイント」をクイズ形式でご紹介する３０分。"
            url="https://sapporoshinyo-h.ed.jp/"
          />
          <JoinSchoolBox
            class="ss"
            img={ss}
            soudankai={false}
            name="札幌聖心女子学院高等学校"
            address="札幌市中央区宮の森2条16丁目10－1"
            postalCode="064-8540 "
            phoneNumber="011-611-9231"
            desc="本校は、キリスト教カトリックの精神を土台とする少人数の女子校で、グローバルクラス、ソフィア・サイエンスクラスの2クラス体制です。探究型学習、国内外の体験学習、海外研修など質の高い学びの機会と生徒が役割を担い活躍する場があります。敷地内に寄宿舎を完備しています。"
            url="https://spr-sacred-heart.ed.jp/"
          />
          <JoinSchoolBox
            class="ss"
            img={ss}
            soudankai={false}
            name="札幌聖心女子学院中学校"
            address="札幌市中央区宮の森2条16丁目10－1"
            postalCode="064-8540"
            phoneNumber="011-611-9231"
            desc="本校は、キリスト教カトリックの精神を土台とする少人数の女子校で、一人ひとりを大切にします。20年以上前から探究型学習に積極的に取り組み、中1からSDGｓを教科横断的に考える機会があります。敷地内に家庭的な雰囲気の寄宿舎を完備し全国から生徒が集まっています。"
            url="https://spr-sacred-heart.ed.jp/"
          />
          <JoinSchoolBox
            class="ss"
            img={ks}
            soudankai={false}
            name="札幌光星高等学校"
            address="札幌市東区北13条東9丁目1-1"
            postalCode="065-0013"
            phoneNumber="011-711-7161"
            desc="本校は、伝統と実績のあるカトリック・ミッションスクールです。全人教育の実践から他者理解・社会貢献ができる若者を育てます"
            url="http://www.sapporokosei.ac.jp/"
          />
          <JoinSchoolBox
            class="ss"
            img={ks}
            soudankai={false}
            name="札幌光星中学校"
            address="札幌市東区北13条東9丁目1-1"
            postalCode="065-0013"
            phoneNumber="011-711-7161"
            desc="本校は、キリスト教の全人教育を実践し、ルクスプログラムなどの主体的な学びから、社会に貢献する若者を育てます。"
            url="http://www.sapporokosei.ac.jp/"
          />
        </div>

        <h3 className="padding20 back-skyblue blue">
          入学パンフレットコーナー
        </h3>
        <p className="font-weight-large content back-grey pamphlet">
          <span className="time">設置期間:</span>
          <span className="when">9/27~10/3 9:00~17:00</span>
          <br />
          <span className="area">北海道新聞社　札幌本社1F DO-BOX横</span>
        </p>
        <p className="padding20 content font-weight-small">
          遺愛女子高等学校、池上学院高等学校、小樽双葉高等学校、小樽明峰高等学校、クラーク記念国際高等学校、札幌大谷高等学校、札幌光星中学・高等学校、札幌新陽高等学校、札幌聖心女子学院中学・高等学校、札幌北斗高等学校、北海学園札幌高等学校、北星学園女子中学・高等学校、北星学園大学附属高等学校、北海道科学大学高等学校、酪農学園大学付属とわの森三愛高等学校
        </p>
        <h3 className="padding20 back-skyblue blue">主催・協力・運営</h3>
        <div className="padding20 content font-weight-small">
          <p className="left">
            主催：北海道新聞社営業局
            <br />
            協力：札幌市小学校長会、札幌市中学校長会、株式会社ワオ・コーポレーション、株式会社オガワヤ
            <br />
            運営：株式会社弘報案内広告社
          </p>
        </div>

        <h3 className="padding20 back-skyblue blue">問い合わせ先</h3>
        <div className="content">
          <p className="font-weight-small">
            北海道新聞社営業局 <a href="tel:011-210-6022">011-210-6022</a>
          </p>
        </div>
        <div className="back-blue white">
          ©2020{" "}
          <a
            className="white font-weight-small"
            href="http://kk.hokkaido-np.co.jp/"
            target="_blank"
            rel="noopener noreferrer"
          >
            北海道新聞社
          </a>
        </div>
      </div>
    </div>
  );
};

export default App;
